export default {
  PRODUCT_REPEATER_CLASS:
    'grid mb-8 md:mb-12 grid-cols-2 small-cards-mobile sm:grid-cols-3 xl:grid-cols-4 gap-x-theme gap-y-8 main-products-grid',
};
